/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    var ShippingStatus;
    (function (ShippingStatus) {
        ShippingStatus[ShippingStatus["None"] = 0] = "None";
        ShippingStatus[ShippingStatus["Unsent"] = 1] = "Unsent";
        ShippingStatus[ShippingStatus["Pickup"] = 3] = "Pickup";
        ShippingStatus[ShippingStatus["Sent"] = 99] = "Sent";
    })(ShippingStatus || (ShippingStatus = {}));
    MoyaComponents.register('store.order-edit-form', function (el) {
        var shippingStatusElm = el.querySelector('#shippingStatus');
        var emailBodyElm = el.querySelector('#emailBody');
        var messageParts = emailBodyElm.value.split('~~');
        var messageMap = {
            pickup: messageParts[0].trim(),
            sent: messageParts[1].trim(),
            default: messageParts[2].trim(),
        };
        var initialShippingStatus = parseInt(shippingStatusElm.value);
        util.delegate(el, 'change', '#shippingStatus', function (e) {
            var delegateTarget = e.delegateTarget;
            var newShippingStatus = parseInt(delegateTarget.value);
            if (initialShippingStatus !== newShippingStatus) {
                if (newShippingStatus === ShippingStatus.Sent) {
                    emailBodyElm.value = messageMap.sent;
                    return;
                }
                if (newShippingStatus === ShippingStatus.Pickup) {
                    emailBodyElm.value = messageMap.pickup;
                    return;
                }
            }
            emailBodyElm.value = messageMap.default;
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
